import { useState, MutableRefObject, useRef } from 'react'
import { useMutation } from '@apollo/client'
import Swal from 'sweetalert2'
import { Col, Row } from 'react-bootstrap'

import withReactContent from 'sweetalert2-react-content'
import TagField from '../../Products/TagField'
import closeicon from '../../../../../_metronic/images/closeSymbol.svg'
import { CREATE_AND_UPDATE_SMART_DOCS_SETUP } from '../../../../../utils/GraphQLAPI'
import { FONT_FAMILY, FONT_SIZE } from '../../../../../utils/GlobalConstants'
import Dropdown from '../../../../sharedComponent/Dropdown/Dropdown'

const MySwal = withReactContent(Swal)

const DocumentSetup = ({ getsSmartDocsFilterAndSetUp, setEditedData, editedData, data }: any) => {
  const [deletedId, setDeletedId] = useState<Array<string>>([])
  const buttonRef = useRef() as MutableRefObject<HTMLButtonElement>
  const [originalIds, setOriginalIds] = useState<Set<string>>(new Set())
  const [fontSize, setFontSize] = useState()
  const [fontFamily, setFontFamily] = useState()

  const [docsSetUpCrud, { loading }] = useMutation(CREATE_AND_UPDATE_SMART_DOCS_SETUP, {
    onCompleted: () => {
      const options: any = {
        customClass: {
          popup: 'swal2-border-radius',
        },
        title: 'Docs setup successful',
        icon: 'success',
        confirmButtonColor: '#3E97FF',
      }
      MySwal.fire(options)
    },
    onError: (err) => {
      MySwal.fire({
        icon: 'error',
        title: err.message,
      })
    },
  })

  const addproductSetup = (
    value: string,
    id: string,
    type: string,
    add: boolean,
    newId: string
  ) => {
    if (!add) {
      setEditedData((prevData: any) => {
        return prevData?.map((item: any) => {
          if (item.id === id) {
            return { ...item, value, id: newId, isModified: true }
          }
          return item
        })
      })
    } else {

      setEditedData((prevData: any) => [
        ...prevData,
        { id, value, type, enum: 'DOCUMENT_TYPE', isNew: true }
      ])
    }
  }
  const removeProductSetup = (id: string, added: boolean) => {
    setEditedData((prevData: any) => {
      return prevData.filter((item: any) => item.id !== id)
    })

    if (!added && !id.startsWith('__tag')) {
      setDeletedId((prev: any) => [...prev, id])
    }
  }
  const FIELD_MAP: any = {
    DOCUMENT_TYPE: { key: "documentType", label: "Document Type" },
  };

  const onSetupAdd = async () => {
    const itemsToAdd = editedData.filter((item: any) => {
      const isOriginalUnchanged = originalIds.has(item.id) && !item.isModified && !item.isNew
      return !isOriginalUnchanged
    })


    const payload = {
      input: {
        addDocDetails: itemsToAdd.map((item: any) => {
          const fieldInfo = FIELD_MAP[item.type || item.enum];
          if (!fieldInfo) {
            return null;
          }

          return {
            [fieldInfo.key]: item.value,
            clientId: item.clientId,
            type: fieldInfo.label,
            ...(item.isModified && !item.isNew && { id: item.id })
          };
        }).filter(Boolean),

        deleteDocDetails: deletedId,
        fontAppearance: {
          fontSize: fontSize,
          fontStyle: fontFamily
        }
      }
    };

    await docsSetUpCrud({ variables: payload });
    buttonRef.current.click();
    handleModalClose();
    getsSmartDocsFilterAndSetUp();
  };

  const handleModalClose = () => {
    setFontSize(undefined)
    setFontFamily(undefined)
    setDeletedId([])
    setOriginalIds(new Set())
  }

  const handleModalOpen = () => {
    setFontSize(data?.getSmartDocDetailsByClientId?.fontAppearance?.fontSize)
    setFontFamily(data?.getSmartDocDetailsByClientId?.fontAppearance?.fontStyle)
    setDeletedId([])
    const originalItemIds = new Set<string>(
      documentTypeList.flatMap((item: any) =>
        (item.names || []).map((name: any) => name.id).filter((id: any) => id)
      )
    )
    setOriginalIds(originalItemIds)
    getsSmartDocsFilterAndSetUp()
  }

  const documentTypeList =
    data?.getSmartDocDetailsByClientId?.groupedDetails.filter(
      (item: any) => item.enum === 'DOCUMENT_TYPE'
    ) || [];

  return (
    <>
      <button
        className='btn btn-primary fs-7'
        onClick={handleModalOpen}
        data-bs-toggle='modal'
        data-bs-target='#kt_modal_1'
      >
        <span>
          <i className='bi bi-gear-fill fs-6'></i>
        </span>
        Document Setup
      </button>

      <div className='modal fade' tabIndex={-1} id='kt_modal_1'>
        <div className='modal-dialog  modal-dialog-scrollable modal-xl'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h5 className='modal-title fs-3 fw-bold'>Document Setup</h5>
              <div
                className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                data-bs-dismiss='modal'
                aria-label='Close'
                onClick={() => handleModalClose()}
              >
                <img src={closeicon} alt='close' />
              </div>
            </div>
            <div className='modal-body pb-0'>
              {documentTypeList.map((item: any, i: number) => (
                <TagField
                  key={item.enum}
                  label={item.type}
                  enumType={item.enum}
                  onAdd={addproductSetup}
                  onRemove={removeProductSetup}
                  name={item.type}
                  initialValue={item.names}
                  className={'text-ellipsis'}
                />
              ))}
            </div>
            <Row className='d-flex align-items-start no-gutters mb-5 px-7'>
              <h5 className='text-gray-700 fs-6 fw-semibold mb-4'>Data Tag Formatting</h5>
              <Col sm md lg={6}>
                <label className='d-flex align-items-center mb-2'>
                  <span className='fs-6 fw-semibold lh-23'>Font Size</span>
                </label>
                <Dropdown
                  fieldName='fontSize'
                  optionList={FONT_SIZE}
                  handleSelectedItem={(e: any) => {
                    setFontSize(e.value)
                  }} selectedVal={fontSize}
                />
              </Col>
              <Col sm md lg={6}>
                <label className='d-flex align-items-center mb-2'>
                  <span className='fs-6 fw-semibold lh-23'>Font Family</span>
                </label>
                <Dropdown
                  fieldName='fontFamily'
                  optionList={FONT_FAMILY}
                  handleSelectedItem={(e: any) => {
                    setFontFamily(e.value)
                  }} selectedVal={fontFamily}
                />
              </Col>
            </Row>
            <div className='modal-footer'>
              <button
                type='button'
                className='btn btn-light'
                data-bs-dismiss='modal'
                onClick={() => handleModalClose()}
                ref={buttonRef}
              >
                Discard
              </button>
              <button type='button' disabled={loading} onClick={() => onSetupAdd()} className='btn btn-primary'>
                Submit

                {loading && (
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default DocumentSetup
